import { Icon } from '@livable/saas-react-components';
import { Button, List, ListItem, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getDateByMonthNameAndDate } from 'src/utils/date';
import useStyles from './styles';
export default function MovingOutInfoBlock(_ref) {
  let date = _ref.date,
    action = _ref.action,
    isAppfolio = _ref.isAppfolio;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(List, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.iconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "lightGrey",
    type: "move-out"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "".concat(t('unit_modal.moving_out_on'), " ").concat(getDateByMonthNameAndDate(date))), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "light"
  }, isAppfolio ? 'Review move-out details.' : t('unit_modal.you_may_cancel')))), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: () => {
      action('move-out');
    },
    'custom-attribute': '439-moving-out-info-block'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  })))));
}